import moment from 'moment'

export default {
  prepareSearch (search) {
    const date = moment(search.name, 'DD/MM/YYYY')
    if (date.isValid() && date.format('DD/MM/YYYY') === search.name) {
      search.validity = date.format('YYYY-MM-DD')
      delete search.name
    }

    return search
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/locks/index/resources/methods.js